// ==============================|| ASSET URL RESOLVER ||============================== //
// Paths coming from the API (core_tenants.logo_url/icon_url, migrace 054/055)
// jsou uložené relativně ke kořeni Vite `public/` adresáře (např.
// "/tenant-logos/tc-brand.png"), ale appka běží pod `base` prefixem
// (vite.config.mjs, VITE_APP_BASE_NAME - "/app/" na do-ra.cz) - bez tohohle
// resolveru by `<img src="/tenant-logos/...">` mířil mimo appku a spadl na
// 404 (reálný bug, 2026-08-29). Použij vždy, když renderuješ URL/cestu z API,
// ne pro assety importované přímo v JS (ty už Vite přepíše sám při buildu).

export function resolveAssetUrl(path) {
  return `${import.meta.env.BASE_URL}${path.replace(/^\//, '')}`;
}
